/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IDataAttributeRenderer } from '../interfaces';
import { IDictionary } from '../interfaces/IDictionary';

const pageName = 'pgname';
const moduleName = 'mname';
const eventType = 'etype';

/**
 * Commerce Insights attribute renderer that generates a 'data-m' telemetry attribute
 */
export const expAttributeRenderer: IDataAttributeRenderer = (
    telemetryId: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    additionalTelemetryData?: any
): IDictionary<string> => {
    if (additionalTelemetryData && pageName in additionalTelemetryData && moduleName in additionalTelemetryData) {
        let eventName = `${additionalTelemetryData[pageName]}.${additionalTelemetryData[moduleName]}.${telemetryId}`;
        if (additionalTelemetryData[eventType]) {
            eventName += `.${additionalTelemetryData[eventType]}`;
        }
        return {
            'data-exp-event-id': eventName
        };
    } else {
        return {};
    }
};
